import { Combobox } from '@ibsys/kit';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { TimeDisplayFormat } from '@/entities/settings';

type Props = {
  /** Название настройки: компонент, интервалы которого она задаёт */
  label: string;
  /** Действующее значение формата интервалов времени этой настройки */
  value: TimeDisplayFormat;
  /** Изменение недоступно без права администрирования общих настроек */
  disabled?: boolean;
  /** Сохранение выбранного значения */
  onChange: (value: TimeDisplayFormat) => void;
};

/** Выбор формата отображения интервалов времени одной настройки группы */
export const TimeDisplayFormatField: FC<Props> = ({ label, value, disabled, onChange }) => {
  const { t } = useTranslation('generalSettings');

  const options = useMemo(
    () => [
      { value: 'TIME', label: t('timeDisplayFormat.time') },
      { value: 'SECOND', label: t('timeDisplayFormat.seconds') },
    ],
    [t],
  );

  return (
    <Combobox
      label={label}
      options={options}
      value={value}
      disabled={disabled}
      isSearchable={false}
      onChange={(selected) => {
        if (selected && selected !== value) onChange(selected as TimeDisplayFormat);
      }}
    />
  );
};
